module.exports = __webpack_public_path__ + "static/media/advice.1eb1b7bb.png";